import { render, staticRenderFns } from "./EndingIcon.vue?vue&type=template&id=4b56edc9&"
import script from "./EndingIcon.vue?vue&type=script&lang=js&"
export * from "./EndingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports